import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHypertrackerFlowsMenuItem = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.3334 11.3333H2.66669M2.66669 11.3333L5.33335 8.66667M2.66669 11.3333L5.33335 14M2.66669 4.66667H13.3334M13.3334 4.66667L10.6667 2M13.3334 4.66667L10.6667 7.33333",
		stroke: "#1A1B23",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.3334 11.3333H2.66669M2.66669 11.3333L5.33335 8.66667M2.66669 11.3333L5.33335 14M2.66669 4.66667H13.3334M13.3334 4.66667L10.6667 2M13.3334 4.66667L10.6667 7.33333",
		stroke: "white",
		strokeOpacity: .5,
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgHypertrackerFlowsMenuItem;
